<template>
  <div class="vx-row match-height">
    <div class="vx-col w-full">
      <vx-card>
        <vs-tabs vs-alignment="fixed" alignment="fixed">
          <vs-tab :label="$t('BasketDetails')" class="mt-2">
            <basket-details ref="mySubComponent"></basket-details>
          </vs-tab>
          <vs-tab :label="$t('OrderPayments')" class="mt-2">
            <order-payments></order-payments>
          </vs-tab>
          <vs-tab :label="$t('Events')" class="mt-2">
            <events></events>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>
<script>
import BasketDetails from "./BasketDetails.vue";
import OrderPayments from "./OrderPayments.vue";
import Events from "./Events.vue";
export default {
  name: "basketManagement_WebSiteBaskets_Details",

  data() {
    return {
      flowState: ""
    };
  },
  components: {
    BasketDetails,
    OrderPayments,
    Events
  },
  mounted() {
    if (this.$refs.mySubComponent) {
      setTimeout(() => {
        this.flowState = this.$refs.mySubComponent.basket.basketFlowState;
      }, 1500);
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.path === "/WebSiteBaskets/Index") {
      if (to.query.state) {
        delete to.query.state;
      }
      if (this.flowState) {
        Object.assign(to.query, { state: this.flowState });
      }

      return next();
    } else {
      return next();
    }
  }
};
</script>
